import { FC } from 'react';

import { TFilterType } from '../models';
import { ISwipeDialogFilterTypeProps } from './models';
import { FilterSwipeDialogTypeBoolean } from './_Type@boolean/FilterSwipeDialogType@boolean';
import { FilterSwipeDialogTypeOptions } from './_Type@options/FilterSwipeDialogType@options';
import { FilterSwipeDialogTypeDateRange } from './_Type@dateRange/FilterSwipeDialogType@dateRange';
import { FilterSwipeDialogTypeString } from './_Type@string/FilterSwipeDialogTypeString';

/** Это компоненты, которые показываются в общем списке фильтров */
export const FILTER_TYPE_COMPONENTS: { [keyof in TFilterType]: FC<ISwipeDialogFilterTypeProps> } = {
  options: FilterSwipeDialogTypeOptions,
  boolean: FilterSwipeDialogTypeBoolean,
  dateRange: FilterSwipeDialogTypeDateRange,
  string: FilterSwipeDialogTypeString,
};
